import React from "react";
import AchievementListing from "../Media/MediaListing";

function MediaSection({ mediaType, profile_user_id, have_edit_access }) {
  return (
    <>
      <div className="mb-2">
        <div>
          <AchievementListing
            viewType="all"
            mediaType={mediaType}
            profile_user_id={profile_user_id}
            have_edit_access={have_edit_access}
            // media={data.media}
            // handleUploadComplete={fetchDetails}
          />
        </div>
      </div>
    </>
  );
}

export default MediaSection;
